
<div class="notifs-wrapper">
  <!-- New notification system: link to /notifications page -->
  <button
    *ngIf="environment.featureFlags?.NEW_NOTIFICATION_SYSTEM"
    routerLink="/notifications"
    (click)="closeSideMenu()"
    class="notifications on"
    tippy
    [options]="{
      content: 'Marketplace notifications',
      placement: 'bottom'
    }">
    <ng-template [ngTemplateOutlet]="bellIcon"></ng-template>
    <span class="new-badge">
      <span class="letter">N</span>
      <span class="letter">E</span>
      <span class="letter">W</span>
    </span>
  </button>
  <!-- Legacy PWA push notifications -->
  <button
    *ngIf="environment.featureFlags?.NEW_NOTIFICATION_SYSTEM !== true"
    class="notifications"
    [class]="(msgSvc.hasPermission$ | async) ? 'on' : 'off'"
    (click)="msgSvc.requestPermission()"
    tippy
    [options]="{
      interactive: true,
      content: (msgSvc.hasPermission$ | async) ? 'Notifications are enabled. You can disable them manually in your device settings.' : '',
      placement: 'bottom'
    }">
    <ng-template
      *ngIf="!msgSvc.loadingPermission; else loadingIcon"
      [ngTemplateOutlet]="bellIcon">
    </ng-template>
  </button>
</div>

<div class="theme-switcher">
  <button [class]="themeSvc.theme$ | async" (click)="switchTheme()">

    <ng-template [ngTemplateOutlet]="themSwitcher"></ng-template>
  </button>

</div>

<div class="cig-wrapper" [class.active]="cigMenuOpen" [class.in-side-menu]="isInSideMenu">

  <button class="icon" (click)="cigMenuOpen = !cigMenuOpen">

    <svg height="10" viewBox="0 0 8 10" width="8" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fill-rule="evenodd">
        <g fill="#000">
          <path d="m0 8h1v1h-1z" />
          <path d="m1 7h1v1h-1z" />
          <path d="m1 9h1v1h-1z" />
          <path d="m2 9h1v1h-1z" />
          <path d="m3 9h1v1h-1z" />
          <path d="m4 9h1v1h-1z" />
          <path d="m2 7h1v1h-1z" />
          <path d="m3 7h1v1h-1z" />
          <path d="m4 7h1v1h-1z" />
          <path d="m5 7h1v1h-1z" />
          <path d="m6 7h1v1h-1z" />
        </g>
        <path d="m6 5h1v1h-1z" fill="#dddddd80" />
        <path d="m6 4h1v1h-1z" fill="#dddddd80" />
        <path d="m6 3h1v1h-1z" fill="#dddddd80" />
        <path d="m6 2h1v1h-1z" fill="#dddddd80" />
        <path d="m6 1h1v1h-1z" fill="#dddddd80" />
        <path d="m6 0h1v1h-1z" fill="#dddddd80" />
        <path d="m6 9h1v1h-1z" fill="#000" />
        <path d="m5 9h1v1h-1z" fill="#000" />
        <path d="m7 8h1v1h-1z" fill="#000" />
        <path d="m6 8h1v1h-1z" fill="#e25c26" />
        <path d="m5 8h1v1h-1z" fill="#c6c6c6" />
        <path d="m4 8h1v1h-1z" fill="#c6c6c6" />
        <path d="m3 8h1v1h-1z" fill="#c6c6c6" />
        <path d="m2 8h1v1h-1z" fill="#c6c6c6" />
        <path d="m1 8h1v1h-1z" fill="#c6c6c6" />
      </g>
    </svg>
  </button>

  <div class="cig-dropdown" *ngIf="cigMenuOpen">

    <ng-container *ngIf="(stateSvc.cigBalances$ | async) as balances">

      <div *ngIf="balances?.cigPrice as price" class="price">

        <div class="label">$CIG Price</div>
        <div class="value">{{ price }}</div>
      </div>

      <div *ngIf="balances?.marketCapUSD as marketCap" class="price">

        <div class="label">$CIG Market Cap</div>
        <div class="value">{{ marketCap | currency }}</div>
      </div>

      <div *ngIf="balances?.balance" class="balance">

        <div class="label">$CIG Balance</div>
        <div class="value">
          {{ (balances?.balance || 0) | formatCash }} $CIG<br />
          {{ (balances?.balance || 0) * (balances?.cigPrice || 0) | currency }} USD
        </div>
      </div>

      <div *ngIf="balances?.claimable" class="claimable"> 

        <div class="label">$CIG Claimable</div>
        <div class="value">{{ (balances?.claimable || 0) | formatCash }}</div>
      </div>
    </ng-container>

    <ng-container *ngIf="(stateSvc.cigCEO$ | async) as ceo">
      <div class="ceo">
        <div class="label">CURRENT CEO</div>
        <div class="value">

          <img [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (ceo | tokenIdParse) + '.svg'"
            [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
            width="30" height="30" />

          <br/>

          <div class="ceo-name">
            <a href="https://cryptopunks.eth.limo/details/{{ ceo | tokenIdParse }}" target="_blank">
              Punk {{ ceo | tokenIdParse }}&nbsp;
              <ng-template [ngTemplateOutlet]="popupIcon"></ng-template>
            </a>
          </div>
                
        </div>
      </div>
    </ng-container>
    <a href="https://cigtoken.eth.limo" class="what" target="_blank">What is $CIG?</a>

    <a href="https://www.sushi.com/ethereum/swap?token0=NATIVE&token1=0xCB56b52316041A62B6b5D0583DcE4A8AE7a3C629" target="_blank" class="buy">Get $CIG</a>
    <a *ngIf="environment.featureFlags?.ENABLE_CIGCLAIM" [routerLink]="['/cigclaim']" class="buy">Claim $CIG</a>
  </div>
</div>

<ng-template #themSwitcher>
  <svg _ngcontent-mcm-c30="" width="24px" height="24px" viewBox="0 0 24 24" version="1.1"
    xmlns="http://www.w3.org/2000/svg">
    <g _ngcontent-mcm-c30="" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path _ngcontent-mcm-c30=""
        d="M2.18177563,4.36361813 L4.36361813,4.36361813 L4.36361813,6.54546062 L2.18177563,6.54546062 L2.18177563,4.36361813 Z M8.72723626,24 L8.72723626,21.8181575 L17.4545394,21.8181575 L17.4545394,24 L8.72723626,24 Z M4.36361813,21.8181575 L4.36361813,19.636315 L8.72723626,19.636315 L8.72723626,21.8181575 L4.36361813,21.8181575 Z M0,8.72723626 L2.18170877,8.72723626 L2.18177563,6.54546062 L4.36361813,6.54546062 L4.36361813,8.72730312 L2.1818425,8.72730312 L2.1818425,15.2726969 L4.36361813,15.2726969 L4.36361813,19.636315 L2.18177563,19.636315 L2.18177563,15.2726969 L0,15.2726969 L0,8.72723626 Z M21.8181575,19.636315 L19.636315,19.636315 L19.636315,21.8181575 L17.4544725,21.8181575 L17.4544725,19.636315 L19.636315,19.636315 L19.636315,15.2726969 L17.4544725,15.2726969 L17.4544725,13.0908544 L19.6362481,13.0908544 L19.636315,10.9090788 L21.8181575,10.9090788 L21.8181575,13.0909212 L19.636315,13.0909212 L19.636315,15.2726969 L21.8181575,15.2726969 L21.8181575,19.636315 Z M10.9090119,4.36361813 L10.9090119,2.1818425 L8.72723626,2.1818425 L8.72723626,-1.13686838e-13 L13.0909212,-1.13686838e-13 L13.0908544,4.36361813 L10.9090788,4.36361813 L10.9090788,6.54546062 L8.72723626,6.54546062 L8.72723626,4.36361813 L10.9090119,4.36361813 Z M4.36361813,4.36361813 L4.36361813,2.18177563 L8.72723626,2.18177563 L8.72723626,4.36361813 L4.36361813,4.36361813 Z M8.72723626,13.0909212 L6.54539376,13.0909212 L6.54539376,6.54546062 L8.72723626,6.54546062 L8.72723626,13.0909212 Z M24,15.2726969 L21.8181575,15.2726969 L21.8181575,10.9090788 L24,10.9090788 L24,15.2726969 Z M8.72723626,15.2726969 L8.72723626,13.0908544 L10.9090788,13.0908544 L10.9090788,15.2726969 L17.4544725,15.2726969 L17.4544725,17.4545394 L10.9090119,17.4545394 L10.9090119,15.2726969 L8.72723626,15.2726969 Z"
        id="moon" fill="#000000" fill-rule="nonzero"></path>
      <path _ngcontent-mcm-c30=""
        d="M13.0909212,19.636315 L13.0909212,23.9999331 L10.9090788,23.9999331 L10.9090788,19.636315 L13.0909212,19.636315 Z M19.6363819,17.4544725 L19.6363819,19.636315 L21.8181575,19.636315 L21.8181575,21.8181575 L19.636315,21.8181575 L19.636315,19.636315 L17.4545394,19.636315 L17.4545394,17.4544725 L19.6363819,17.4544725 Z M8.72730312,17.4544725 L8.72730312,15.27263 L15.2727637,15.2726969 L15.2727637,17.4545394 L8.72730312,17.4544725 Z M10.9091456,6.54539376 L10.9091456,6.54539376 L15.2727637,6.54539376 L15.2727637,8.72716939 L17.4546062,8.72723626 L17.4546062,15.2726969 L15.2727637,15.2726969 L15.2726969,8.72730312 L8.72730312,8.72723626 L8.72730312,6.54539376 L10.9091456,6.54539376 Z M21.8181575,10.9090119 L21.8181575,13.0908544 L19.636315,13.0908544 L19.636315,10.9090119 L21.8181575,10.9090119 Z M19.6363819,4.36388558 L19.6363819,6.54572808 L17.4545394,6.54572808 L17.4545394,4.36388558 L19.6363819,4.36388558 Z M19.6363819,2.18177563 L21.8182244,2.18177563 L21.8182244,4.36361813 L19.6363819,4.36361813 L19.6363819,2.18177563 Z M6.54552749,4.36361813 L6.54552749,6.54546062 L4.36368499,6.54546062 L4.36368499,4.36361813 L6.54552749,4.36361813 Z M4.36368499,2.18177563 L4.36368499,4.36361813 L2.1818425,4.36361813 L2.1818425,2.18177563 L4.36368499,2.18177563 Z M13.0909881,4.36361813 L10.9091456,4.36361813 L10.9091456,5.68434189e-14 L13.0909881,5.68434189e-14 L13.0909881,4.36361813 Z M6.54546062,8.72723626 L8.72730312,8.72723626 L8.72730312,15.2726969 L6.54546062,15.2726969 L6.54546062,8.72723626 Z M4.36375186,13.0908544 L2.18190936,13.0908544 L2.18190936,10.9090119 L4.36375186,10.9090119 L4.36375186,13.0908544 Z M2.1818425,13.0908544 L-2.27373675e-13,13.0908544 L-2.27373675e-13,10.9090119 L2.1818425,10.9090119 L2.1818425,13.0908544 Z M24,13.0908544 L21.8181575,13.0908544 L21.8181575,10.9090119 L24,10.9090119 L24,13.0908544 Z M6.54552749,19.6360476 L4.36368499,19.6360476 L4.36368499,17.4542051 L6.54552749,17.4542051 L6.54552749,19.6360476 Z M4.36375186,21.8181575 L2.18190936,21.8181575 L2.18190936,19.636315 L4.36375186,19.636315 L4.36375186,21.8181575 Z"
        id="sun" fill="#000000" fill-rule="nonzero"></path>
    </g>
  </svg>
</ng-template>


<ng-template #bellIcon>
  <svg width="20px" height="22px" viewBox="0 0 20 22" version="1.1" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M12,20 L12,22 L8,22 L8,20 L12,20 Z M20,18 L20,20 L18,20 L18,18 L20,18 Z M14,18 L14,20 L12,20 L12,18 L8,18 L8,20 L6,20 L6,18 L0,18 L0,14 L2,14 L2,16 L14,16 L14,14 L16,14 L16,16 L18,16 L18,18 L14,18 Z M4,6 L4,14 L2,14 L2,6 L4,6 Z M14,12 L14,14 L12,14 L12,12 L14,12 Z M18,6 L18,12 L16,12 L16,6 L18,6 Z M12,10 L12,12 L10,12 L10,10 L12,10 Z M10,8 L10,10 L8,10 L8,8 L10,8 Z M8,6 L8,8 L6,8 L6,6 L8,6 Z M16,4 L16,6 L14,6 L14,4 L16,4 Z M6,4 L6,6 L4,6 L4,4 L6,4 Z M14,2 L14,4 L12,4 L12,2 L14,2 Z M4,2 L4,4 L2,4 L2,2 L4,2 Z M12,0 L12,2 L8,2 L8,0 L12,0 Z M2,0 L2,2 L0,2 L0,0 L2,0 Z" id="off" fill="rgba(var(--text-color), 1)"></path><path d="M12,20 L12,22 L8,22 L8,20 L12,20 Z M8,20 L6,20 L6,18 L0,18 L0,14 L2,14 L2,16 L18,16 L18,14 L20,14 L20,18 L14,18 L14,20 L12,20 L12,18 L8,18 L8,20 Z M18,6 L18,14 L16,14 L16,6 L18,6 Z M4,6 L4,14 L2,14 L2,6 L4,6 Z M16,4 L16,6 L14,6 L14,4 L16,4 Z M6,4 L6,6 L4,6 L4,4 L6,4 Z M8,2 L8,4 L6,4 L6,2 L8,2 Z M14,2 L14,4 L12,4 L12,2 L14,2 Z M12,0 L12,2 L8,2 L8,0 L12,0 Z" id="on" fill="rgba(var(--text-color), 1)"></path></g></svg>
</ng-template>

<ng-template #loadingIcon>
  <app-loader></app-loader>
</ng-template>

<ng-template #popupIcon>
  <svg class="popup-icon" _ngcontent-ng-c2943368829="" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-ng-c2943368829="" d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd"></path></svg>
</ng-template>